import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.css'
import './iconfont/iconfont.css';
import api from './api';
import echarts from 'echarts';
import 'echarts/theme/dark.js'
import FullCalendar from 'vue-fullcalendar'
// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {
//   ak: '1hqg34NFaCw9jcv0xG82cI7uINFaXGGM'
// })

import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import '../public/static/UEditor/ueditor.config'
import '../public/static/UEditor/ueditor.all'
import '../public/static/UEditor/lang/zh-cn/zh-cn'
import '../public/static/UEditor/themes/default/css/ueditor.css';

Vue.component('vue-ueditor-wrap', VueUeditorWrap)

Vue.use(FullCalendar)
Vue.use(ElementUI);
Vue.prototype.$echarts = echarts
Vue.prototype.$api = api;
Vue.config.productionTip = false
Vue.prototype.msgSuccess = function(msg) {
    this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function(msg) {
    this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function(msg) {
    this.$message.info(msg);
}
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')